import { Paper, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { BarcodePreviewGraphic } from './Graphic'
import { BarcodePreviewPositionLabels } from './PositionLabels'
import { buildBarcodePreviewModel } from './model'

type Props = {
  startPosition: number
  endPosition: number
}

export const BarcodePreview: FC<Props> = ({ startPosition, endPosition }) => {
  const preview = buildBarcodePreviewModel({ startPosition, endPosition })

  return (
    <Paper variant="outlined" sx={{ p: 2, bgcolor: 'white', borderRadius: 1 }}>
      <Typography
        variant="body2"
        sx={{ fontWeight: 'bold', mb: 1.5, color: 'text.primary' }}
      >
        プレビュー
      </Typography>
      <Stack sx={{ userSelect: 'none' }}>
        <BarcodePreviewGraphic
          bars={preview.bars}
          svgWidth={preview.svgWidth}
        />
        <BarcodePreviewPositionLabels positions={preview.positions} />
      </Stack>
    </Paper>
  )
}
